import React from "react";
import ReactPlayer from "react-player";
import {
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  GIF_UPLOAD,
  YOUTUBE_URL,
} from "../../Constants/types";
import { getYoutubeId } from "../../Utils/utils";

import "./index.css";

export default function MediaContentViewer({ media_type, media_url }) {
  if (media_type === VIDEO_UPLOAD)
    return (
      <div className="content-pan" style={{ width: "100%", height: "100%" }}>
        <ReactPlayer
          url={media_url}
          width="100%"
          height="100%"
          playing={true}
          controls={true}
          muted
        />
      </div>
    );
  if (media_type === YOUTUBE_URL)
    return (
      <iframe
        title="video"
        className="content-pan"
        src={`//www.youtube.com/embed/${getYoutubeId(
          media_url
        )}?modestbranding=1&showinfo=0`}
        frameBorder="0"
        allowFullScreen
      ></iframe>
    );
  if (media_type === IMAGE_UPLOAD || media_type === GIF_UPLOAD) {
    return (
      <div
        className="img-container"
        style={{ backgroundImage: `url("${media_url}")` }}
      ></div>
    );
  }
  return (
    <div
      className="content-pan"
      style={{
        backgroundImage: `url(${media_url})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
        height: 200,
      }}
    ></div>
  );
}



// WEBPACK FOOTER //
// ./src/components/MediaContentViewer/index.js